import { SankeyLinkConfig } from '@blockworks/platform/api/research/studio/visualizations';
import { Big } from '@blockworks/platform/libs/big';

const getSumFromRange = (link: SankeyLinkConfig, data: any[]) => {
    const {
        columnKey,
        sumRange: { from, to },
    } = link;
    const length = data.length;

    if (typeof from !== 'number' || typeof to !== 'number') {
        console.log('Invalid sum range. Indices must be defined as numbers.', {
            from,
            to,
            length: data.length,
        });
        return;
    }

    if (from < 0 || to >= length || from > to) {
        console.log('Invalid start or end index.', { start: from, end: to, length: length });
        return;
    }

    let sum = Big(0);

    for (let i = from; i <= to; i++) {
        const value: string = data?.[i]?.[columnKey];

        try {
            sum = sum.plus(Big(value));
        } catch (err) {
            console.log(err);
        }
    }
    return sum.toNumber();
};

export { getSumFromRange };
